import { ONE_DEGREE_IN_RADIANS } from "../math/constants";

/**
 * Computes the world size of a camera's frame at the given distance.
 *
 * @param vFov the vertical field of view in degrees
 * @param aspect the aspect ratio of the camera, i.e. width/height, so ~1.77
 * for a 16:9 frame.
 * @param distance the distance in scene units (inches for CPS) to the plane
 * @returns a tuple of width and height of a rectangle that would cover the
 * given field of view at the specified distance.
 */
export const computeFrameSize = (
    vFov: number, aspect: number, distance: number): [number, number] =>
{
    const
        // half the vertical field of view, converted from degrees to radians
        hvFov = 0.5 * vFov * ONE_DEGREE_IN_RADIANS,
        height = 2 * distance * Math.tan(hvFov),
        width = height * aspect; // height * (width/height) -> width
    return [ width, height ];
}
